interface Settings {
  resolution: number
  showStatistics: boolean
  timeOffsetCorrection: number
}

const defaultSettings: Settings = {
  resolution: 1,
  showStatistics: true,
  timeOffsetCorrection: 0
}

const LOCALSTORAGE_KEY = 'anni.sync'

export let settings: Settings = getSettings()

export let paused = false
function getSettings(): Settings {
  const settingsString = localStorage.getItem(LOCALSTORAGE_KEY)

  if (settingsString === null) {
    storeSettings(defaultSettings)
    return defaultSettings
  }

  return JSON.parse(settingsString) as Settings
}

function storeSettings(newSettings: Settings): void {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(newSettings))
  settings = newSettings
}

function setPaused(_paused: boolean): void {
  paused = _paused
}

export function changeResolution(newResolution: number): void {
  const settings = getSettings()
  const newSettings: Settings = {
    ...settings,
    resolution: newResolution
  }
  storeSettings(newSettings)
}

function changeTimeOffsetCorrection(offset: number): void {
  const settings = getSettings()
  const timeOffsetCorrection = settings.timeOffsetCorrection + offset
  console.log('new timeOffsetCorrection', timeOffsetCorrection)
  const newSettings: Settings = {
    ...settings,
    timeOffsetCorrection
  }
  storeSettings(newSettings)
}

function toggleStatisticsDisplay() {
  const settings = getSettings()
  const newShowStatistics = !settings.showStatistics
  storeSettings({
    ...settings,
    showStatistics: newShowStatistics
  })
}

document.body.addEventListener('keyup', (e: KeyboardEvent) => {
  switch (e.key) {
    case '1':
      changeResolution(1)
      window.location.reload()
      break
    case '2':
      changeResolution(2)
      window.location.reload()
      break
    case '3':
      changeResolution(3)
      window.location.reload()
      break
    case '4':
      changeResolution(4)
      window.location.reload()
      break
    case '6':
      changeResolution(6)
      window.location.reload()
      break
    case '8':
      changeResolution(8)
      window.location.reload()
      break

    case 'i':
      toggleStatisticsDisplay()
      window.location.reload()
      break

    case 'w':
      changeTimeOffsetCorrection(100) // 100ms
      break
    case 'q':
      changeTimeOffsetCorrection(-100) // -100ms
      break

    case 'p':
      setPaused(!paused)
  }
})

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') storeSettings(settings)
})

window.addEventListener('pagehide', () => storeSettings(settings))
